<template>
  <Button @click="onSave">
    SAVE
  </Button>
</template>

<script>
export default {
  methods: {
    onSave() {
      this.$emit("save");
    }
  }
};
</script>
